import React, {Fragment, useState} from "react";

export default ({person}) => {

    const [opened, setOpened] = useState(false);

    const hasDesc = person.role || person.email || person.phone;
    const hasBio = !!person.bio;

    return <Fragment>
        <a href="#" className="staff-member__inner"
           data-fade="down"
           onClick={(e) => {
            e.preventDefault();
            setOpened(true);
            return false;
           }}>
            <div className="staff-member__image" style={{backgroundImage: `url('${person.thumb}')`}} />
            <div className="staff-member__text">
                <div>
                    <h3>{person.name}</h3>
                    {!!person.role && <p className="staff-member__role">{person.role}</p>}
                </div>
                {!!hasBio && <div className="staff-member__action">
                    <span className="btn">Read Bio</span>
                </div>}

            </div>
        </a>

        {!!opened && <div className={'staff-popup'}>
            <div className={'container'}>
                <div className={'staff-popup__inner'}>

                    <a href='#' className={'staff-popup__close'}
                       onClick={(e) => {
                           e.preventDefault();
                           setOpened(false);
                           return false;
                       }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.527" height="10.527" viewBox="0 0 10.527 10.527">
                            <g transform="translate(-1336.237 -1281.237)">
                                <line x2="7.698" y2="7.698" transform="translate(1337.651 1282.651)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
                                <line x2="7.698" y2="7.698" transform="translate(1345.349 1282.651) rotate(90)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
                            </g>
                        </svg>
                    </a>

                    <div className={'staff-popup__image'}
                         style={{backgroundImage: `url('${person.image}')`}} />
                    <div className={'staff-popup__body'}>
                        <div className={'staff-popup__top'}>
                            <h3 className={'staff-popup__title'}>
                                {person.name}
                            </h3>
                            {!!hasDesc && <div className="staff-popup__role">
                                {!!person.role && <span className="staff-popup__role-item">{person.role}</span>}
                                {!!person.email && <span className="staff-popup__role-item">
                                    E: <a href={`mailto:${person.email}`} target="_blank">{person.email}</a>
                                </span>}
                                {!!person.phone && <span className="staff-popup__role-item">
                                    T: <a href={`mailto:${person.phone}`} target="_blank">{person.phone}</a>
                                </span>}
                            </div>}
                        </div>
                        <div className={'staff-popup__desc'}>
                            <div dangerouslySetInnerHTML={{__html: person.bio}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>}

    </Fragment>

}
